export const HTTP_STATUS = {
    Ok: 200,
    Conflict: 409
} as const;